import React from 'react'
import styles from './gamescard.module.scss'
import { ERCText } from 'components/text'

const GamesCard = ({ img, title }) => {
    return (
        <div className={styles.body} >
            <img src={img} alt='' />
            <div className={styles.desc} >
                <ERCText align='center' color='#FFD600' size='18px' weight='700' lHeight='20px' >{title}</ERCText>
            </div>
        </div>
    )
}

export default GamesCard